import { Outlet } from '@tanstack/react-router'

import { withResourceRecord } from '@/shared/contexts'
import { PageHeader, PageTabs, Screen } from '@/shared/ui/Layout'

import { getConfig } from './config'
import { useAccountSections } from './useAccountSections'

/**
 * Shell da área "Minha conta".
 *
 * O `withResourceRecord` fica aqui, e não em cada seção, para que o recurso
 * `user` seja resolvido uma vez só para a área inteira — trocar de seção não
 * dispara requisição nova. As seções leem registro e `Form` de
 * `useResourceRecordContext()`.
 *
 * `NetworkingSection` é a exceção deliberada: ela carrega o próprio formulário
 * porque salva em endpoint diferente, e conviver com este provider não é
 * conflito — ela simplesmente não o consome.
 */
export const AccountLayout = withResourceRecord(() => {
  const sections = useAccountSections()

  return (
    <Screen>
      <Screen.Context>
        {/* Volta para o início: comportamento global do `PageHeader`. */}
        <PageHeader title="Minha conta" />
      </Screen.Context>
      <Screen.Sticky className="pb-3 pt-2">
        <PageTabs aria-label="Seções da conta" items={sections} />
      </Screen.Sticky>
      <Screen.Content className="pb-8">
        <Outlet />
      </Screen.Content>
    </Screen>
  )
}, getConfig)
